export const paymentKeys = {
  all: ['payments'] as const,
  byOrg: (orgId: string) => [...paymentKeys.all, orgId] as const,
  campaignPayments: (campaignId: string) => ['campaign-payments', campaignId] as const,
  dashboardPayments: (orgId: string) => ['dashboard-payments', orgId] as const,
};
